import { flatten, keyBy, map } from 'lodash'
import { createSelector } from '@reduxjs/toolkit'

export const
  allGroups = state => (state.groups?.groups || []),

  allFeeds = createSelector(allGroups, groups => flatten(map(groups, "feeds"))),

  feedsByKey = createSelector(allFeeds, feeds => keyBy(feeds, "key")) // { [feed.key]: feed, ... }
